import { render } from "./viewComplaint.vue?vue&type=template&id=0c97cfd8&scoped=true"
import script from "./viewComplaint.vue?vue&type=script&lang=js"
export * from "./viewComplaint.vue?vue&type=script&lang=js"

import "./viewComplaint.vue?vue&type=style&index=0&id=0c97cfd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c97cfd8"]])

export default __exports__